import React from 'react';

import { fieldValueShape } from 'app/shapes/bibPage';

import './ContentLabel.scss';

export default function ContentLabel({ fieldValue }) {
  const label = fieldValue.get('contentLabel');

  if (label) {
    return <div className="cp-bib-content-label">{label}</div>;
  }

  return null;
}

ContentLabel.propTypes = {
  fieldValue: fieldValueShape
};
